import type { RoomList, Room } from '../components/RoomSelector/RoomSelector.types';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { ObservableMap } from 'mobx';

export function createDefaultRoomListViewState() {
    let userCurrentRoomList: RoomList;
    var userConfig = getUserConfiguration();
    if (userConfig?.ViewStateConfiguration) {
        userCurrentRoomList = {
            email: userConfig.ViewStateConfiguration.SchedulingLastUsedRoomListEmailAddress,
            name: userConfig.ViewStateConfiguration.SchedulingLastUsedRoomListName,
        };
    }

    return {
        currentRoomList: userCurrentRoomList,
        isSearchingForRooms: false,
        preferredRoomLists: [],
        roomLists: [],
        rooms: [],
        tagsIndex: new ObservableMap<string, Room[]>(),
        defaultRoomList: { ...userCurrentRoomList },
        selectedRoomList: userCurrentRoomList,
        showPlaceType: false,
    };
}
